/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';

const Notification = ({
    showNotification, notificationMessage, notificationType = 'success', handleShowNotification = undefined, jobId = null, onClose = undefined
}) => {
    const [visibleType, setVisibleType] = useState(notificationType);

    useEffect(() => {
        if (showNotification) {
            setVisibleType(notificationType);
        }
    }, [showNotification, notificationType]);

    useEffect(() => {
        if (showNotification && typeof handleShowNotification === 'function') {
            const timer = setTimeout(() => {
                handleShowNotification();
            }, 3000);
            return () => clearTimeout(timer);
        }
        return undefined;
    }, [showNotification, handleShowNotification]);

    return (
        <div className={`${showNotification && jobId === null ? 'toaster-wrapper' : ''}`}>
            <div className={`notification-bottom ${showNotification ? '' : 'hideMe'}`}>
                <span className={`${visibleType === 'success' ? 'notify-success-icon' : visibleType === 'info' ? 'notify-info-icon' : 'notify-error-icon'}`} />
                <span>{notificationMessage}</span>
                {!!jobId && (
                <span className="notification-close" onClick={onClose} aria-hidden="true">
                    Okay
                </span>
                )}
            </div>
        </div>
    );
};

export default Notification;